import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.orderDetails || initialState;

export const selectOrderDetails = createSelector(
  [selectDomain],
  (state) => state.details
);

export const selectIsOrderDetailPageLoading = createSelector(
  [selectDomain],
  (state) => state.isOrderDetailPageLoading
);
export const selectOrderDetailPageError = createSelector(
  [selectDomain],
  (state) => state.orderDetailPageError
);

export const selectSampleDetails = createSelector(  [selectDomain],
  (state) => state.sampleDetails
);

export const selectCheckForGRN = createSelector(
  [selectDomain],
  (state) => state.checkForGRN
);

export const selectLoading = createSelector(
  [selectDomain],
  (state) => state.loading
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);

export const selectRequestingHardcopy = createSelector(
  [selectDomain],
  (state) => state.requestingHardcopy
);

export const selectRaisingDispute = createSelector(
  [selectDomain],
  (state) => state.raisingDispute
);

export const selectCommodities = createSelector(
  [selectDomain],
  (state) => state.commodities
);

export const selectStates = createSelector(
  [selectDomain],
  (state) => state.states
);

export const selectNewOrder = createSelector(
  [selectDomain],
  (state) => state.newOrder
);

export const selectProjectCodes = createSelector(
  [selectDomain],
  (state) => state.projectCodes
);

export const selectCompanies = createSelector(
  [selectDomain],
  (state) => state.companies
);

export const selectDistricts = createSelector(
  [selectDomain],
  (state) => state.districts
);

export const selectSamplers = createSelector(
  [selectDomain],
  (state) => state.samplers
);

export const selectDropdowns = createSelector(
  [selectDomain],
  (state) => state.dropdowns
);

export const selectIsSubmittingCorrection = createSelector(
  [selectDomain],
  (state) => state.isSubmittingCorrection
);

export const selectReplacementLoading = createSelector(
  [selectDomain],
  (state) => state.createReplacementOrder
);

export const selectComments = createSelector(
  [selectDomain],
  (state) => state.comments
);

export const selectCommentsSuccess = createSelector(
  [selectDomain],
  (state) => state.commentsSuccess
);

export const selectLogisticPartners = createSelector(
  [selectDomain],
  (state) => state.logisticPartners
);
export const selectLabs = createSelector([selectDomain], (state) => state.labs);

export const selectSectors = createSelector(
  [selectDomain],
  (state) =>  state.sectors
);

export const selectLabAnalytics = createSelector(
  [selectDomain],
  (state) =>  state.labAnalytics
);

export const selectOrderCorrectionReasons = createSelector(
  [selectDomain],
  (state) => state.orderCorrectionReasons
);

export const selectAgencies = createSelector(
  [selectDomain],
  (state) => state.agencies
);